<template>
    <v-container>
        <v-row>
            <v-col class="form__data">
                <p
                    :class="{
                        'display-2': $vuetify.breakpoint.mdAndUp,
                        'display-1': $vuetify.breakpoint.smAndDown,
                        'mb-6': true,
                    }"
                    class="font-weight-bold"
                >
                    Datos del programa contable
                </p>
                <v-form v-model="valid" style="width: 100%" @submit.prevent="submit" class="form__program__data rounded-lg pa-2 mx-2 mb-8">
                    <v-container>
                        <v-row v-if="program && (!(Object.keys(program.params).includes('hide') && program.params['hide'].includes('welcome_accounting_program_directory')))">
                            <v-col cols="12">
                                <v-text-field
                                    solo
                                    v-model="form.accounting_program_directory"
                                    label="Directorio programa contable"
                                    :rules="requiredRule"
                                    :error="error_directory"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <div v-if="program && (!(Object.keys(program.params).includes('hide') && program.params['hide'].includes('welcome_network_drive')))">
                            <p class="mt-6 mb-0 headline black--text">
                                ¿El directorio está en una unidad de red?
                            </p>
                            <v-row>
                                <v-col cols="12">
                                    <v-radio-group class="pt-0 mt-0" v-model="form.is_network_drive" :rules="[(v) => (v === false || v === true) || 'required']">
                                        <v-container>
                                            <v-row>
                                                <v-col cols="6">
                                                    <v-card
                                                        :elevation="form.is_network_drive === true ? 10 : 2"
                                                        color="transparent"
                                                        class="plans d-flex justify-space-around mb-5"
                                                        @click="form.is_network_drive = true"
                                                    >
                                                        <v-row class="row">
                                                            <v-col cols="2" class="ma-1 pa-0 col">
                                                                <div class="flex-grow-1 d-flex align-center transparent">
                                                                    <v-radio :value="true" style="background-color: transparent"></v-radio>
                                                                </div>
                                                            </v-col>
                                                            <v-col cols="9" class="ma-1 pa-0 col">
                                                                <div class="flex-grow-1 d-flex align-center headline transparent">
                                                                    <span>Si</span>
                                                                </div>
                                                            </v-col>
                                                        </v-row>
                                                    </v-card>
                                                </v-col>
                                                <v-col cols="6">
                                                    <v-card
                                                        :elevation="form.is_network_drive === false ? 10 : 2"
                                                        color="transparent"
                                                        class="plans d-flex justify-space-around mb-5"
                                                        @click="form.is_network_drive = false"
                                                    >
                                                        <v-row class="row">
                                                            <v-col cols="2" class="ma-1 pa-0 col">
                                                                <div class="flex-grow-1 d-flex align-center transparent">
                                                                    <v-radio :value="false" style="background-color: transparent"></v-radio>
                                                                </div>
                                                            </v-col>
                                                            <v-col cols="9" class="ma-1 pa-0 col">
                                                                <div class="flex-grow-1 d-flex align-center headline transparent">
                                                                    <span>No</span>
                                                                </div>
                                                            </v-col>
                                                        </v-row>
                                                    </v-card>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-radio-group>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-if="form.is_network_drive" 
                                        solo
                                        v-model="form.network_drive_user"
                                        label="Usuario"
                                        :rules="requiredRule"
                                        :error="error_user"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-if="form.is_network_drive"
                                        solo
                                        v-model="form.network_drive_pass"
                                        label="Contraseña"
                                        :rules="requiredRule"
                                        :error="error_pass"
                                        :type="show_pass ? 'text' : 'password'"
                                        :append-icon="show_pass ? 'mdi-eye' : 'mdi-eye-off'"
                                        @click:append="show_pass = !show_pass"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </div>
                        <v-row>
                            <v-col cols="12" offset-md="6" md="2">
                                <v-btn block @click="cancel">
                                    Cancelar
                                </v-btn>
                            </v-col>
                            <v-col cols="12" md="2">
                                <v-btn block color="secondary" @click="previousStep">
                                    Atrás
                                </v-btn>
                            </v-col>
                            <v-col cols="12" md="2">
                                <v-btn
                                    :disabled="!valid || submitting"
                                    block
                                    type="submit"
                                    color="secondary"
                                >
                                    Siguiente
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import PolicyDialogLink from "./PolicyDialogLink";
import PolicyServices from "./PolicyServices";
import ContratoTratamientoDatos from "./ContratoTratamientoDatos";
import { user as api_user } from "@/api/user";
import { STATUS } from "../../store/modules/me";
import ContractComponent from "../ContractComponent.vue";
import { mapFields } from 'vuex-map-fields';

export default {
    name: "AccountingProgramData",
    components: {
        PolicyDialogLink,
        PolicyServices,
        ContratoTratamientoDatos,
        ContractComponent,
    },
    data() {
        return {
            valid: false,
            submitting: false,
            form: {
                accounting_program_directory: '',
                is_network_drive: false,
                network_drive_user: '',
                network_drive_pass: '',
                status: STATUS.PREPARING_FORMATION,
            },
            requiredRule: [(v) => Boolean(v) || "required"],
            show_pass: false,

            crispMsg: "Rellenando datos del programa contable",
        };
    },
    created() {
        this.fillForm();
        this.startCrispThread(this.crispMsg);
    },
    methods: {
        previousStep() {
            this.$emit("previousStep");
        },
        async cancel() {
            try {
                const response = await api_user.setUserInfo({
                    status: STATUS.ACTIVE
                });
                this.setUserData(response.data.results);
                if (this.currentCompany) {
                this.$router.push('/' + this.currentCompany + '/documents');
                } else {
                this.$router.push("/initial");
                }
            } catch (error) {

            }
        },
        async submit() {
            this.submitting = true;
            try {
                const response = await api_user.setUserInfo(this.form);
                this.setUserData(response.data.results);
                await api_user.createLead({'state': 'signup5'});
                this.endCrispThread(this.crispMsg);
            } catch (error) {
                console.error(error);
            } finally {
                this.submitting = false;
            }
        },
        fillForm() {
            this.form.accounting_program_directory = this.userData.accounting_program_directory;
            this.form.is_network_drive = this.userData.is_network_drive;
            this.form.network_drive_user = this.userData.network_drive_user;
            this.form.network_drive_pass = this.userData.network_drive_pass;
        },
        ...mapActions({
            setUserData: "me/setUserData",
            setPrograms: "tutorial/setPrograms",
            startCrispThread: "me/startCrispThread",
            endCrispThread: "me/endCrispThread",
        }),
        ...mapState([
            'currentCompany'
        ])
    },
    computed: {
        ...mapGetters({
            userData: "me/userData",
            programas: "tutorial/programs",
        }),
        error_directory() {
            return false;
        },
        error_user() {
            return false;
        },
        error_pass() {
            return false;
        },
        program() {
            let that = this;
            let program = this.programas.filter(
                function(data){ return data.id == that.userData.selected_program }
            );
            return program[0];
        },
    },
    watch: {
        userData: function () {
            this.fillForm();
        },
    },
};
</script>

<style lang="scss" scoped>

.form__program__data {
    background-color: #F2F1FF;
}
.plans .row .col div {
    cursor: pointer;
    background-color: var(--v-secondary-base);
    color: black;
    margin-bottom: 10px;
    margin-top: 10px;
    width: 100%;
    padding: 2px 10px;
    font-weight: bold;
    border-radius: 5px;
    height: 70%;
    &.transparent {
        background-color: transparent;
    }
    &.selected {
        background-color: yellow;
        color: var(--v-secondary-base);
    }
    span {
        margin: auto;
    }
}
.black--text {
    color: black;
}
@media screen and (max-width: 960px) {

    .form__data {
        padding: 0 !important;
    }

    .black--text {
        font-size: 16px !important;
    }

}
</style>
